<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="996px" :before-close="handleClose">
            <div class="main scroll-auto" v-if="info != null">
                <el-form ref="form" label-width="140px">
                    <h3 class="sub-title">基础设置</h3>
                    <el-form-item label="商品名称：">
                        <p >{{ info.goods_name }}</p>
                    </el-form-item>
                    <el-form-item label="分类：">
                        <p>{{ info.standard_id }}</p>
                    </el-form-item>
                    <el-form-item label="销量：">
                        <p >{{ info.sales_nums }}</p>
                    </el-form-item>
                    <el-form-item label="库存：">
                        <p >{{ info.merchandise_inventory }}</p>
                    </el-form-item>
                    <el-form-item label="参与活动：">
                        <p v-if="info.activity_name">{{ info.activity_name }}</p>
                    </el-form-item>
                    <el-form-item label="参与活动商品数量：">
                        <p>{{ info.max_sales_num }}</p>
                    </el-form-item>
                    <el-form-item label="销售价：">
                        <p >{{ Number(info.price_sell) }} 元</p>
                    </el-form-item>
                    <el-form-item label="市场价：">
                        <p >{{ Number(info.price_market) }} 元</p>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <p v-if="info.status">{{ status_opt[info.status - 1] }}</p>
                    </el-form-item>
                    <h3 class="sub-title">更多设置</h3>
                    <el-form-item label="是否开启拼团：" v-if="activeName == 'activity_team'">
                        <p >{{ info.is_open_leader_price == 1 ? "开启" : "关闭" }}</p>
                    </el-form-item>
                    <el-form-item label="拼团价：" v-if="activeName == 'activity_team'">
                        <p>{{ Number(info.price) || 0 }} 元</p>
                    </el-form-item>
                    <el-form-item label="团长价：" v-if="activeName == 'activity_team'">
                        <p>{{ Number(info.leader_price) || 0 }} 元</p>
                    </el-form-item>
                    <el-form-item label="是否开启预热：" v-if="activeName == 'activity_team'">
                        <p v>{{ info.activity_prepare == 1 ? "开启" : "关闭" }}</p>
                    </el-form-item>
                    <el-form-item label="返现金额：" v-if="activeName == 'activity_share' || activeName == 'activity_link'">
                        <p>{{ Number(info.reward_cash) || 0 }} 元</p>
                    </el-form-item>
                    <el-form-item label="返现比例：" v-if="activeName == 'activity_share' || activeName == 'activity_link'">
                        <p >{{ Number(info.reward_share) }} %</p>
                    </el-form-item>
                    <el-form-item label="是否开启拼团：" v-if="activeName == 'activity_team'">
                        <p >{{ info.is_open_leader_price == 1 ? "开启" : "关闭" }}</p>
                    </el-form-item>
                    <el-form-item label="返现次数：" v-if="activeName == 'activity_share'">
                        <p >  {{info.rule_type==1?'不限':info.rule_type}} 次</p>
                    </el-form-item>
                    <el-form-item label="购买次数：" v-if="activeName == 'activity_link'">
                        <p>{{info.limit_order_num}}  </p>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button plain @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            status_opt: ["未开始", "进行中", "已结束", "失效"],
            info: { spu_data: {} },
        };
    },
    props: {
        activeName: {
            type: String,
        },
    },
    methods: {
        bindData(row) {
            this.info = JSON.parse(JSON.stringify(row));
            console.log(this.info,'this.info')
        },
        handleClose() {
            this.info = null;
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    .main {
        min-height: 450px;
        height: 450px;
    }
}
.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
    &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>